module.exports = __webpack_public_path__ + "img/33-ABITO-MELODIA-U-COLORI-GARZA3.ffa67d11.jpg";